import authReducer from "@/store/auth";
import siteReducer from "@/store/site";
import { injectStoreAxios } from '@/utils/axios';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from "react-redux";
import { persistReducer, persistStore } from "redux-persist";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import storage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";
import layoutReducer from './layout';


export const encryptor = encryptTransform({
    secretKey: import.meta.env.VITE_APP_SECRET_KEY,
    onError: function (error) {
        console.log('error', error)
    }
})

const authPersistConfig = {
    key: '@QRCODE:auth',
    storage: storage,
    blacklist: [],
    transforms: [encryptor]
}

const sitePersistConfig = {
    key: '@QRCODE:site',
    storage: sessionStorage,
    blacklist: [],
}


const rootReducer = combineReducers({
    layout: layoutReducer,
    auth: persistReducer(authPersistConfig, authReducer),
    site: persistReducer(sitePersistConfig, siteReducer),
})



export const store = configureStore({
    reducer: rootReducer,
    devTools: import.meta.env.MODE === 'development',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
}, )



export const persistor = persistStore(store)

injectStoreAxios(store)


// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppStore: () => AppStore = useStore